import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import css_248z from './main-container.scss.js';

class MainContainer extends s {
    render() {
        return x `<div class="main-container"><div class="main-container-background"><div class="main-container-background-left-image"></div><div class="main-container-background-right-image"></div></div><div class="main-container-content"><slot></slot></div></div>`;
    }
}
MainContainer.styles = css_248z;
customElements.define('main-container', MainContainer);

export { MainContainer };
